
import { FC, createContext } from 'react';
import { BookAppointmentContextValue, BookAppointmentContextProps } from './BookAppointmentContext.types';

export const BookAppointmentContext = createContext<BookAppointmentContextValue>({
  isError: false,
  isLoading: true,
  isSuccess: false,
  handleBookAppointment: undefined
});

const BookAppointmentContextProvider: FC<BookAppointmentContextProps> = (props: BookAppointmentContextProps) => {
  const { children, value } = props;
  return <BookAppointmentContext.Provider value={value}>{children}</BookAppointmentContext.Provider>;
};

export default BookAppointmentContextProvider;
